let baseURL;

// development
// baseURL = 'https://dev-api-irp.appinsnap.com';

// Production
baseURL = 'https://api.irp.ict-administration.com';

export { baseURL };
